import { useQuery } from '@tanstack/react-query';
import { Plus, FolderTree } from 'lucide-react';
import { api, Department } from '../../lib/api';

export function DepartmentListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['departments'],
    queryFn: () => api.get<{ data: Department[] }>('/api/departments', { flat: 'true' }),
  });

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>部門マスタ</h1>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium" style={{ backgroundColor: 'var(--accent-color)' }}><Plus size={18} />新規登録</button>
      </div>
      <div className="card overflow-hidden">
        {isLoading ? (
          <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-blue-600/30 border-t-blue-600 rounded-full animate-spin" /></div>
        ) : data?.data.length === 0 ? (
          <div className="text-center py-12"><FolderTree size={48} className="mx-auto mb-4" style={{ color: 'var(--text-muted)' }} /><p style={{ color: 'var(--text-secondary)' }}>部門が登録されていません</p></div>
        ) : (
          <table>
            <thead><tr>
              <th style={{ color: 'var(--text-primary)' }}>コード</th>
              <th style={{ color: 'var(--text-primary)' }}>部門名</th>
              <th style={{ color: 'var(--text-primary)' }}>階層</th>
              <th style={{ color: 'var(--text-primary)' }}>状態</th>
            </tr></thead>
            <tbody>
              {data?.data.map((dept) => (
                <tr key={dept.id}>
                  <td className="font-mono" style={{ color: 'var(--text-primary)' }}>{dept.code}</td>
                  <td style={{ color: 'var(--text-primary)', paddingLeft: `${(dept.level - 1) * 1.5}rem` }}>{dept.name}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{dept.level}</td>
                  <td><span className={`badge ${dept.isActive ? 'badge-success' : 'badge-error'}`}>{dept.isActive ? '有効' : '無効'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

